import { CommonModule } from '@angular/common';
import { Component, input, model } from '@angular/core';
import { FormCheckboxControl } from '@angular/forms/signals';
import { BaseConfig } from '../common/config/config.adapter';

@Component({
  selector: 'lepi-toggle',
  templateUrl: './toggle.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class Toggle extends BaseConfig implements FormCheckboxControl {
  disabled = input<boolean>(false);
  checked = model<boolean>(false);

  handleChange(ev: Event) {
    ev.stopPropagation();
    this.checked.set((ev.target as HTMLInputElement).checked);
  }
}
